import MailCampaignForm from './mail-campaign-form';

export default MailCampaignForm;
